var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ucont"},[_c('vue-dropzone',{key:this.msg,ref:"myDropzone",attrs:{"id":"dropzone","options":{
      url: '/upload',
      // chunking: true,
      // retryChunks: true,
      maxFilesize: 100000,
      dictDefaultMessage: this.msg,
      complete: this.addFile
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }